// Default width for the expanded sidebars (Playlist / Rekordbox / Serato /
// Traktor / VirtualDJ / Likes / Followed-artists). The wide-screen value
// (340px) is comfortable on a 14"+ display but crowds main content on a
// 13" MacBook (1440 logical on MBA, 1512 on MBP), so we drop to 300 for
// viewports under 1500px. Evaluated once at slice-init time — the user
// can still drag-resize from there.
export function getDefaultSidebarWidth() {
    if (typeof window === 'undefined') return 340;
    return window.innerWidth < 1500 ? 300 : 340;
}
